import { gql } from '@apollo/client';
import TENANT_SUPPLIER from 'api/fragments/TENANT_SUPPLIER';
const ADD_TENANT_SUPPLIER = gql `
  ${TENANT_SUPPLIER}
  mutation AddTenantSupplier(
    $tenantId: ID!
    $name: String!
    $shortName: String!
    $code: String!
    $vatNumber: String
    $countryOfOrigin: String
    $addressPostalCode: String
    $addressCity: String
    $addressStreet: String
    $addressNumber: String
    $emailAddress: String
    $contactPhone: String
  ) {
    addSupplier(
      tenantId: $tenantId
      name: $name
      shortName: $shortName
      code: $code
      vatNumber: $vatNumber
      countryOfOrigin: $countryOfOrigin
      addressPostalCode: $addressPostalCode
      addressCity: $addressCity
      addressStreet: $addressStreet
      addressNumber: $addressNumber
      emailAddress: $emailAddress
      contactPhone: $contactPhone
    ) {
      supplier {
        ...TenantSupplierFragment
      }
    }
  }
`;
export default ADD_TENANT_SUPPLIER;
